// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import { colors, modalStyles } from '../../shared/styles';

import Select from '../shared/forms/Select';
import DropdownList from '../shared/forms/DropdownList';
import Loader from '../../components/Loader/Loader';

const StyledExportListModal = styled(ReactModal)`
    width: 400px;
    margin: 40px auto 0 auto;
    background: ${colors.white};
    border-radius: 4px;

    & .title {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .title h3 {
        margin: 0;
    }

    & .actions {
        text-align: right;
        padding: 10px;
        border-top: 1px solid ${colors.offWhite};
    }

    & .actions button {
        padding: 5px 10px;
        border: 0;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
    }

    & .actions button[disabled] {
        opacity: 0.5;
    }

    & .actions .primary {
        background: ${colors.orange.default};
        color: ${colors.white};
    }

    & .actions .secondary {
        background: ${colors.offWhite};
        color: ${colors.grey.default};
    }

    & .content p {
        padding: 0 20px 16px;
        margin-bottom: 0;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .summary {
        text-align: center;
    }

    & .summary p {
        border-bottom: none;
    }

    & .summary a {
        display: inline-block;
        background: ${colors.orange.default};
        color: ${colors.white};
        border: none;
        border-radius: 4px;
        text-align: center;
        text-decoration: none;
        padding: 12px 24px;
        margin-bottom: 16px;
        font-size: 14px;
    }
`;

let ExportListForm = (props: any) => {
    const {
        contactList,
        handleSubmit,
        submitting,
        onCancel,
        onGenerate,
        exportState,
    } = props;

    const contactData = Array.isArray(contactList)
        ? contactList.map(contact => {
              return {
                  id: contact.contactId,
                  label: `${contact.contactForenames} ${contact.contactSurname}`,
              };
          })
        : [];

    const { generating, generated, matches, downloadUrl } = exportState;

    const showForm = !generating && !generated;
    const matchProperty = matches && matches === 1 ? 'property' : 'properties';
    const matchText = `${matchProperty} matched your search criteria.`;
    const downloadSuffix =
        downloadUrl && downloadUrl.indexOf('.csv') > -1 ? 'CSV' : 'PDF';

    return (
        <form onSubmit={handleSubmit}>
            <div className="title">
                <h3>Export Property List</h3>
            </div>

            <div className="content">
                {showForm &&
                    <div>
                        <p>
                            An export list will be generated with the currently
                            selected search criteria.
                        </p>

                        <Field
                            name="contactId"
                            label="Contact (optional)"
                            component={DropdownList}
                            data={contactData}
                        />

                        <Field
                            name="format"
                            label="Export Format"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="CSV">CSV</option>
                            <option value="PDF">PDF</option>
                        </Field>
                    </div>}

                {generating &&
                    <Loader message="Generating export, please wait..." />}

                {generated &&
                    <div className="summary">
                        <p>
                            Your export is ready to download!<br />{' '}
                            <b>{matches || 0}</b> {matchText}
                        </p>

                        <a href={downloadUrl} target="_blank">
                            Download {downloadSuffix}
                        </a>
                    </div>}
            </div>

            <div className="actions">
                <button
                    className="secondary"
                    disabled={submitting}
                    onClick={onCancel}
                    type="button"
                >
                    {generated ? 'Close' : 'Cancel'}
                </button>

                {!generated &&
                    <button className="primary" onClick={onGenerate}>
                        {submitting ? 'Generating...' : 'Generate'}
                    </button>}
            </div>
        </form>
    );
};

ExportListForm = reduxForm({
    form: 'propertyExportList',
})(ExportListForm);

const ExportListModal = (props: any) => {
    const { contactList, onCancel, onGenerate, isOpen, exportState } = props;

    return (
        <StyledExportListModal
            contentLabel="Create Export List"
            shouldCloseOnOverlayClick={false}
            closeTimeoutMS={200}
            isOpen={isOpen}
            style={modalStyles}
        >
            <ExportListForm
                contactList={contactList}
                exportState={exportState}
                onCancel={onCancel}
                onSubmit={onGenerate}
                initialValues={{ format: 'CSV' }}
            />
        </StyledExportListModal>
    );
};

export default ExportListModal;



// WEBPACK FOOTER //
// ./src/components/PropertyForms/ExportListModal.js